import { configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
// import storage from "redux-persist/lib/storage"; // Use localStorage
import { combineReducers } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage/session"; // Alternatively, use sessionStorage
import approvalCustomerReducer from "./features/slices/ApprovalCustomerSlice";
import LogsReducer from "./features/slices/BulkUploadSlice";
import businessunitReducer from "./features/slices/BusinessUnitSlice";
import CustomerTypeReducer from "./features/slices/CustomerTypeSlice";
import disputeDetailsReducer from "./features/slices/DisputeDetailsSlice";
import EmailSettingReducer from "./features/slices/EmailSettingSlice";
import paymentReducer from "./features/slices/PaymentSlice";
import authReducer from "./features/slices/authSlice";
import creditlineReducer from "./features/slices/creditLineSlice";
import customerBackOrderReducer from "./features/slices/customerBackOrderSlice";
import customerPriceListReducer from "./features/slices/customerPriceListSlice";
import customerRegionReducer from "./features/slices/customerRegionSlice";
import customerReducer from "./features/slices/customerSlice";
import deparmentReducer from "./features/slices/departmentSlice";
import designationReducer from "./features/slices/designationSlice";
import employeeReducer from "./features/slices/employeeSlice";
import feedbackReducer from "./features/slices/feedbackSlice";
import modalReducer from "./features/slices/modalSlice";
import multilevelReducer from "./features/slices/multilevelApprovalSlice";
import notificationReducer from "./features/slices/notificationSlice";
import raisedDisputeReducer from "./features/slices/raisedDisputeSlice";
import roleReducer from "./features/slices/roleSlice";
import userGuideReducer from "./features/slices/userGuideSlice";
import PrivilegeReducer from "./features/slices/PrivilegeSlice";
import promotionReducer from "./features/slices/PromotionSlice";


// Combine reducers explicitly (already implied in your setup)
const rootReducer = combineReducers({
  auth: authReducer,
  approvalCustomer: approvalCustomerReducer,
  payment: paymentReducer,
  dispute: disputeDetailsReducer,
  role: roleReducer,
  modal: modalReducer,
  deparment: deparmentReducer,
  designation: designationReducer,
  employee: employeeReducer,
  businessunit: businessunitReducer,
  multilevel: multilevelReducer,
  customerType: CustomerTypeReducer,
  customerregion: customerRegionReducer,
  raisedDispute: raisedDisputeReducer,
  customer: customerReducer,
  feedback: feedbackReducer,
  creditLine: creditlineReducer,
  notifications: notificationReducer,
  userGuide: userGuideReducer,
  customerPriceList: customerPriceListReducer,
  customerBackOrder: customerBackOrderReducer,
  customerBulkUpload: LogsReducer,
  EmailSetting: EmailSettingReducer,
  Privilege: PrivilegeReducer,
  promotiondata: promotionReducer,
});

// Persistence configuration
const persistConfig = {
  key: "root",
  storage, // Use localStorage
  whitelist: [
    "auth", // User info for role-based rendering
    "customer", // ViewLogisticDetails and podDateMap for instant table display
    "role", // Static role data for permissions
    "deparment", // Static department data
    "designation", // Static designation data
    "businessunit", // Static business unit data
    "customerType", // Static customer type data
    "customerregion", // Static region data
    "userGuide", // Static user guide content
    "notifications", // Session-specific notifications
    "dispute", // Dynamic dispute data
    "raisedDispute", // Dynamic dispute data
    "multilevel", // Dynamic approval workflows
    "feedback", // Transient feedback data
    "customerBackOrder", // Dynamic backorder data
    "CustomerBulkUpload", // Transient bulk upload data
    "customerBulkUpload", // Transient logs
    "approvalCustomer", // Dynamic approval customer data
    "creditLine", // Dynamic credit line data
    "payment", // Dynamic payment data for transactions
    "employee",
  ],
  blacklist: ["modal"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore redux-persist actions to avoid non-serializable warnings
        ignoredActions: [
          "persist/PERSIST",
          "persist/REHYDRATE",
          "persist/PURGE",
        ],
        // Ignore specific paths if needed (e.g., non-serializable data in slices)
        ignoredPaths: ["some.path.to.nonSerializableData"],
      },
    }),
});

export const persistor = persistStore(store);

export default store;
